import { useApi } from '@root/src/web/lib/useApi';
export const useDiscussion = (url) => {
    const { data } = useApi(url, {
        // The default for dedupingInterval is 2 seconds but we want to wait longer here because the cache time
        // for a discussion is at least 15 seconds
        dedupingInterval: 8000,
    });
    return {
        commentCount: data?.discussion?.commentCount,
        isClosedForComments: data?.discussion?.isClosedForComments,
    };
};
